import type { ReactNode, ReactElement } from "react";
import { Popover as BasePopover } from "@base-ui/react/popover";
import styles from "./Popover.module.css";

type PopoverSide = "top" | "right" | "bottom" | "left";
type PopoverAlign = "start" | "center" | "end";

interface PopoverProps {
  readonly children: ReactElement;
  readonly content: ReactNode;
  readonly side?: PopoverSide;
  readonly align?: PopoverAlign;
  readonly open?: boolean;
  readonly onOpenChange?: (open: boolean) => void;
}

export function Popover({
  children,
  content,
  side = "bottom",
  align = "end",
  open,
  onOpenChange,
}: PopoverProps) {
  return (
    <BasePopover.Root open={open} onOpenChange={onOpenChange}>
      <BasePopover.Trigger render={children} />
      <BasePopover.Portal>
        <BasePopover.Positioner side={side} align={align} sideOffset={8}>
          <BasePopover.Popup className={styles.popup}>
            {content}
          </BasePopover.Popup>
        </BasePopover.Positioner>
      </BasePopover.Portal>
    </BasePopover.Root>
  );
}
